import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers'

import { StyledError } from '../../../../theme/components/StyledError'
import { useUpdateSubprocesForEntity } from '../../hooks/useUpdateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'

interface Props {
  subproces: Subproces
  onClose: () => void
}

export const PlanSchouw = ({ subproces, onClose }: Props) => {
  const { mutate: updateSubprocesForEntity, error } =
    useUpdateSubprocesForEntity()

  const [errors, setErrors] = useState<
    Partial<Record<keyof Subproces, boolean>>
  >({})

  const [dueDate, setDueDate] = useState<Date | null>(null)

  const validate = () => {
    const dueDateError = !dueDate

    setErrors({
      dueDate: dueDateError,
    })

    return !dueDateError
  }

  const onSubmitClick = () => {
    if (validate()) {
      const proces: Partial<Subproces> = {
        _id: subproces._id,
        // @ts-expect-error - checked in validate
        dueDate: dueDate.toISOString(),
        status: 'planned',
      }

      const body = {
        entity: subproces.entity,
        subprocesInfo: proces,
      }

      updateSubprocesForEntity(body, { onSuccess: () => onClose() })
    }
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Grid container sx={{ width: '100%' }} spacing={1}>
          <Grid size={{ xs: 6 }}>
            <TextField
              fullWidth
              disabled
              label="Toegewezen aan"
              value={subproces.assignedTo}
              error={errors['assignedToError']}
              variant="standard"
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <DatePicker
              label="Geplande uitvoerdatum"
              value={dueDate}
              onChange={setDueDate}
              displayWeekNumber
              disablePast
              slotProps={{
                field: { clearable: true },
                textField: {
                  variant: 'standard',
                  sx: { pr: 1 },
                  error: errors.dueDate,
                  fullWidth: true,
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button onClick={onSubmitClick} variant={'contained'}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
